import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AppComponent} from '../../app.component';
import {MenuFooterLabels, MenuFooterPaths} from "../../enums/menu-footer";
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./footer.component.less']
})

export class FooterComponent implements OnInit {
  menu: any[] = [];
  global_texts: any = null;
  year = new Date().getFullYear();
  code_footer: string = "";

  constructor(
    public app: AppComponent,
    private router: Router) {
  }

  ngOnInit(): void {
    this.menu = this.app.sharedHelper.constructMenu(MenuFooterLabels, MenuFooterPaths);
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;

      const _module_uuid = this.app.sharedHelper.getModuleUuidFromUrl();
      this.getCodeFooterSwitchModuleUuid(_module_uuid);
    });

    // Listen to route changes and call `getCodeFooterSwitchModuleUuid`
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd)) // Listen to NavigationEnd events only
      .subscribe(() => {
        const _module_uuid = this.app.sharedHelper.getModuleUuidFromUrl();
        this.getCodeFooterSwitchModuleUuid(_module_uuid);
      });
  }

  getCodeFooterSwitchModuleUuid(_module_uuid: string) {
    switch (_module_uuid) {
      case "f3ea5105-1688-4b2c-a062-691924de46aa":
      case "531272fc-2c7b-4eac-a76b-76778cf81f8c":
        this.code_footer = "NPUB-202407-003 – Octobre 2024";
        break;
      case "7b0fe7ad-72bf-481c-8cc4-ecc59f7cda33":
        this.code_footer = "AR-202407-022 – Octobre 2024";
        break;
      case "347f9421-29c3-4789-b9f8-ca034edea9f6":
        this.code_footer = "AR-202407-059 – Octobre 2024";
        break;
      case "6ddab3d7-2b0a-48db-9628-b513834b0087":
        this.code_footer = "NPUB-202408-001 – Octobre 2024";
        break;
      case "1d24ef4f-4f89-41f2-9b45-7c2c298259ba":
        this.code_footer = "AR-202408-002 – Octobre 2024";
        break;
      default:
        this.code_footer = "Octobre 2024";
        break;
    }
  }

  goToPathOrLinkExterne(_linkOrPath:string){
    if (_linkOrPath.includes('http')) {
      window.open(_linkOrPath, '_blank');
    } else {
      this.app.router.navigate([_linkOrPath]);
    }
  }
}
